module.exports = "img/flags/PA.ec2529e.png";